//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  computed: {
    // 是否有票
    hasTicket: function hasTicket() {
      return this.hasTickets[this.value.pid];
    }
  },
  methods: {
    // 关闭弹窗
    close: function close() {
      this.$emit('input', null);
    },
    buy: function buy() {
      // 设置store
      this.$store.dispatch('setSelectPayInfo', this.value); // 关闭弹窗并拉起支付

      this.close();
      this.openPay();
    }
  }
};